import React, {useState} from 'react';
import ChatWindow from "./ChatWindow";

const MainWindow = ({firstMessage, ...props}) => {
  const [conversationID, setConversationID] = useState('');
  const [chatPanelClasses] = useState('ie-chat-window--panel panel-chatwindow grow h-100');

  const closeOverlay = () => {
    document.querySelector('.ie-chatbot__toggle')?.click();
  };

  return (
    <div className="ie-chat-window--main-window">
      <div className="right-side">
        <div className="flex justify-between items-center mb-4">
          <p className="font-greed text-3xl md:text-[3.8rem] mb-0">How can we help?</p>
          <button
            type="button"
            className="relative flex h-[44px] w-[44px] items-center justify-center rounded-full border border-1 border-black bg-white cursor-pointer hover:bg-[#eee]"
            onClick={closeOverlay}
            aria-label="Close chat overlay"
          >
            <span className="sr-only">Close</span>
            <span
              aria-hidden="true"
              className="absolute h-[2px] w-[18px] rotate-45 bg-black"
            ></span>
            <span
              aria-hidden="true"
              className="absolute h-[2px] w-[18px] -rotate-45 bg-black"
            ></span>
          </button>
        </div>
        <ChatWindow
          conversationID={conversationID}
          setConversationID={setConversationID}
          className={chatPanelClasses}
          firstMessage={firstMessage} />
      </div>
    </div>
  );
};

export default MainWindow;
